
export const loomSdkStates = {
  sdkNotLoaded: "Initializing",
  noLoomTokenGenerated: "Currently unavailable",
  recordingNotSupported: "Recording not supported",
  loading: "Loading...",
  loaded: "Loaded",
}

export const loomRecordButtonStates = {
  record: 'Record video',
  recording: 'Recording...',
  uploading: 'Uploading...',
}